// © Microsoft Corporation. All rights reserved.

/**
 * Enum for timestamp type.
 */
export enum TimestampType {
    None,
    JustNow,
    LessThanOneHour,
    Today,
    Yesterday,
    ThisWeek,
    ThisYear,
    FullDate,
    InMinutes
}